export default __webpack_public_path__ + "static/media/facebook-icon-2.04bf49f5.svg";